import { Alert } from "antd";
import { useGetApplicantDetailsQuery } from "../hooks/api/useGetApplicantDetailsQuery";

const ProgramInfo = ({ className }: { className?: string }) => {
  const { applicantDetails: user } = useGetApplicantDetailsQuery();
  const fullName = `${user?.firstName} ${user?.lastName}`;
  return (
    <Alert
      type="info"
      message={
        <div>
          <p>
            Applicant: <b>{fullName}</b>
          </p>
          <p>
            Program: {" "}
            <b>
               {user?.programName}
              {/* {user?.programType} {user?.programName} */}
            </b>
          </p>
          <p>
            Area of Specialization: <b>{user?.specialization}</b>
          </p>
          <p>
            Mode of study: <b>{user?.modeOfStudyName}</b>
          </p>
        </div>
      }
      style={{ fontSize: "18px" }}
      className={className}
    />
  );
};

export default ProgramInfo;
